<template>
<div class="pp-mobile-footer__nav"
    @touchdown="hideOverlays"
    @mousedown="hideOverlays">
    <router-link 
        to="/browse" 
        class="pp-mobile-footer__nav__item">
        <i class="fa fa-fw fa-mobile-phone"></i>
        <span>Browse</span>
    </router-link>
    <router-link 
        to="/search" 
        class="pp-mobile-footer__nav__item">
        <i class="fa fa-fw fa-search"></i>
        <span>Search</span>
    </router-link>
    <router-link 
        to="/queue" 
        class="pp-mobile-footer__nav__item">
        <i class="fa fa-fw fa-list-ul"></i>
        <span>Queue</span>
    </router-link>
    <router-link 
        to="/account" 
        class="pp-mobile-footer__nav__item">
        <i class="fa fa-fw fa-user"></i>
        <span>Account</span>
    </router-link>
</div>
</template>


<script>
import EventBus from '../EventBus.js';

export default {
    name: 'mobile-nav',
    data() {
        return {

        };
    },
    methods: {
        hideOverlays() {
            console.log('hideOverlays');
            EventBus.emit('mobile.hideNowPlaying');
        },
    },
}
</script>



// WEBPACK FOOTER //
// MobileNav.vue?7ab7d860